<div class="container">
    <div class="row text-center">
        <div class="col-12 text-center">
            <img src="../../../assets/images/presskit-logo.png" width="50%" />
            <p class="title">PRESS KIT</p>
            <p class="sub-title">PLEASE FIND BELOW ALL NEEDED RESOURCES RELATED TO THE BAND.<br />
                CLICKING THE THUMBNAIL WILL PREVIEW THE RESOURCE. CLICK DOWNLOAD TO DOWNLOAD IT.</p>
        </div>
    </div>
    <div class="row text-center">
        <div class="col-lg-3 col-md-6">
            <p class="card-title">PROMO PHOTO</p>
            <!-- <a href="https://storage.googleapis.com/angelcrypt-downloads/promo-photo.jpg" target="_blank"><div class="card" style="background-color: transparent;"><img src="../../../assets/icons/photo.png" /></div></a> -->
            <div class="card" (click)="showAlert('photo')"><img src="../../../assets/icons/photo.png" /></div>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/Promo%20Photo.zip">DOWNLOAD</a></p>
        </div>

        <div class="col-lg-3 col-md-6">
            <p class="card-title">LOGO & EMBLEM</p>
            <div class="card" (click)="showAlert('logo')"><img src="../../../assets/images/pk-icon-2.png" /></div>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/Logo%20%26%20Emblem.zip">DOWNLOAD</a></p>
        </div>

        <div class="col-lg-3 col-md-6">
            <p class="card-title">BIOGRAPHY</p>
            <a href="https://storage.googleapis.com/angelcrypt-downloads/bio.pdf" target="_blank"><div class="card"><i class="icon fas fa-feather-alt"></i></div></a>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/Biography.zip">DOWNLOAD</a></p>
        </div>

        <div class="col-lg-3 col-md-6">
            <p class="card-title">TECH RIDER</p>
            <a href="https://storage.googleapis.com/angelcrypt-downloads/tech_rider.pdf" target="_blank"><div class="card"><img src="../../../assets/icons/band.png" /></div></a>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/Tech%20Rider.zip">DOWNLOAD</a></p>
        </div>

        <!-- <div class="col-lg-3 col-md-6">
            <p class="card-title">DIGITAL BACKDROP</p>
            <a href="https://storage.googleapis.com/angelcrypt-downloads/digital_backdrop.jpg" target="_blank"><div class="card"><img src="../../../assets/icons/backdrop.jpg" /></div></a>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/digital_backdrop.zip">DOWNLOAD</a></p>
        </div> -->

        <div class="col-lg-3 col-md-6">
            <p class="card-title">DIGITAL BACKDROP</p>
            <div class="card" (click)="showAlert('backdrop')"><img src="../../../assets/icons/backdrop.jpg" /></div>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/digital_backdrop.zip">DOWNLOAD</a></p>
        </div>

        <div class="col-lg-3 col-md-6">
            <p class="card-title">EPK</p>
            <a href=".../../../../../assets/pdfs/epk.pdf" target="_blank"><div class="card"><i class="icon far fa-newspaper"></i></div></a>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/Press%20Kit.zip">DOWNLOAD</a></p>
        </div>

        <div class="col-lg-3 col-md-6 ">
            <p class="card-title">AUDIO</p>
            <div class="card" (click)="showAlert('audio')"><i class="icon fas fa-volume-up"></i></div>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/Audio.zip">DOWNLOAD</a></p>
        </div>

        <div class="col-lg-3 col-md-6">
            <p class="card-title">VIDEO</p>
            <div class="card" (click)="showAlert('video')"><i class="icon fas fa-video"></i></div>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/Video.zip">DOWNLOAD</a></p>
        </div>

        <div class="col-lg-3 col-md-6" style="margin: 0px auto">
            <p class="card-title">LINKS & CONTACTS</p>
            <a href="https://storage.googleapis.com/angelcrypt-downloads/contacts.pdf" target="_blank"><div class="card"><i class="icon far fa-address-card"></i></div></a>
            <p class="card-footer"><a href="https://storage.googleapis.com/angelcrypt-downloads/Contacts.zip">DOWNLOAD</a></p>
        </div>
    </div>
    <br />
    <div class="row text-center">
        <div class="col-12 text-center">
            <a href="https://storage.googleapis.com/angelcrypt-downloads/Full%20Archive.zip"><p class="download">DOWNLOAD ALL</p></a>
        </div>
    </div>
</div>
